import React from "react";
import styled, { css } from "styled-components";
import { tablet } from "../BreakPoints";
import { colors } from "../colors/color";

const headerColors = ['black', 'gray', 'white', 'placeholder', 'error'] as const;
type HeaderColor = typeof headerColors[number];

const getColorCode = (color:HeaderColor) => {
    switch (color) {
        case 'black':
            return colors.text.normal;
        case 'gray':
            return colors.text.gray.contrastForWhite;
        case 'white':
            return colors.text.white;
        case 'placeholder':
            return colors.text.inactive;
        case 'error':
            return colors.text.state.error;
        default:
            return colors.text.gray.dark;
    }
};

export type HeaderProps = React.StyleHTMLAttributes<HTMLHeadingElement> &
{
    color?: HeaderColor,
    marginTop?:number,
    marginBottom?:number
}

const headerShared = css<HeaderProps>`
    color: ${props => getColorCode(props.color || 'black')};
    font-family: 'Noto Sans', sans-serif;
    line-height: 1.4;
    margin-top:${props => props.marginTop ===undefined ? '0px' : props.marginTop+'px'};
    margin-bottom:${props =>props.marginBottom===undefined ? '0px' : props.marginBottom+'px'};
`;

export const h1Styling = css<HeaderProps>`
    ${headerShared};

    font-size: 24px;
    font-weight: 700;
    text-transform: uppercase;

    @media (max-width: ${tablet}px) {
        font-size: 20px;
    };
`;
export const H1 = styled.h1<HeaderProps>`
    ${h1Styling}
`;



export const h2Styling = css`
    ${headerShared};

    font-size: 22px;
    font-weight: 500;

    @media (max-width: ${tablet}px) {
        font-size: 18px;
    }
`
export const H2 = styled.h2<HeaderProps>`
    ${h2Styling};
`;



export const h3Styling = css`
    ${headerShared};

    font-size: 16px;
    font-weight: 400;
`
export const H3 = styled.h3<HeaderProps>`
    ${h3Styling};
`;



export const h4Styling = css`
    ${headerShared};
    
    font-size: 16px;
    font-weight: 500;
`;
export const H4 = styled.h4<HeaderProps>`
    ${h4Styling}
`;


export const H1Page = styled(H1)<HeaderProps>`
    ${headerShared};
    margin-top: 48px;
`;